import React from 'react';
import { graphql } from 'gatsby';

import Layout from '@/components/organisms/Layout';
import Seo from '@/components/atoms/Seo';
import DataTreatmentContainer from '@/containers/DataTreatment/DataTreatmentContainer';

import { LegalPagesQuery } from '../../../graphql-types';

interface Props {
  data: LegalPagesQuery;
}

export const query = graphql`
  query DataTreatmentShopLegalPages {
    prismicLegalPages {
      data {
        meta_title_data
        meta_description_data
        ...DataTreatment
      }
    }
  }
`;

const DataTreatment = ({ data }: Props): JSX.Element => {
  const { meta_title_data, meta_description_data } =
    data?.prismicLegalPages?.data || {};
  return (
    <Layout invertNav type="magasin">
      <Seo
        title={meta_title_data || 'title'}
        description={meta_description_data || 'description'}
      />
      <DataTreatmentContainer data={data} type="magasin" />
    </Layout>
  );
};

export default DataTreatment;
